import React, { useRef } from 'react'
import { trans } from '../../../../_providers/Translation'
import Help from '../../../partials/Help'
import Dropdown from '@/components/partials/Dropdown'

const ServicingFilter = (props) => {
    const categoriesDropdownRef = useRef(null)
    const brandsDropdownRef = useRef(null)
    const contractorsDropdownRef = useRef(null)

    const handleSearch = e => {
        let name = e.target.name
        let val = e.target.value

        props.handleSearch(name, val)
    }

    const handleClearFilters = () => {
        props.handleSearch('name', '')
        categoriesDropdownRef.current.reset()
        brandsDropdownRef.current.reset()
        contractorsDropdownRef.current.reset()
        props.handleSearch('category_id', '')
        props.handleSearch('brand_id', '')
        props.handleSearch('contractor_id', '')
        props.handleSearch('model', '')
    }

    const handleCategory = data => {

        let val = data.id || ''

        if (data.id || data.name == '') {
            props.handleSearch('category_id', val)
        }
    }

    const handleBrand = data => {

        let val = data.id || ''

        if (data.id || data.name == '') {
            props.handleSearch('brand_id', val)
        }
    }

    const handleContractor = data => {

        let val = data.id || ''

        if (data.id || data.name == '') {
            props.handleSearch('contractor_id', val)
        }
    }

    return (
        <>
            <form className="filter-standard">
                <div className='col'>
                    <input
                        type='search'
                        name='name'
                        onChange={handleSearch}
                        onKeyUp={handleSearch}
                        value={props.filter.name}
                        placeholder={trans('labels.search')}
                    />
                </div>
                <div className='col'>
                    <Dropdown
                        inputIdValue={Number(props.filter.contractor_id)}
                        url="contractors/dropdown-list"
                        renderText={data => {
                            return data.name
                        }}
                        onChange={data => {
                            handleContractor(data)
                        }}
                        inputPlaceholder={trans('tables.contractor')}
                        ref={contractorsDropdownRef}
                    />
                </div>
                <div className='col'>
                    <Dropdown
                        inputIdValue={Number(props.filter.category_id)}
                        url="partners/categories/all"
                        renderText={data => {
                            return data.name
                        }}
                        onChange={data => {
                            handleCategory(data)
                        }}
                        inputPlaceholder={trans('labels.category')}
                        ref={categoriesDropdownRef}
                    />
                </div>
                <div className='col'>
                    <Dropdown
                        inputIdValue={Number(props.filter.brand_id)}
                        url="partners/brands/all"
                        renderText={data => {
                            return data.name
                        }}
                        onChange={data => {
                            handleBrand(data)
                        }}
                        inputPlaceholder={trans('labels.brand')}
                        ref={brandsDropdownRef}
                    />
                </div>
                <div className='col'>
                    <input
                        type='search'
                        name='model'
                        onChange={handleSearch}
                        onKeyUp={handleSearch}
                        value={props.filter.model}
                        placeholder={trans('labels.model')}
                    />
                </div>
                <div className='col'>
                    <button type='button' className='button-clear-filter' onClick={handleClearFilters}>
                        {trans('buttons.clearFilter')}
                    </button>
                </div>
            </form>
        </>
    )
}
export default ServicingFilter